var exports = {
  "w": "xe533113f--767cd3--header",
  "H": "xe533113f--767cd3--cell",
  "l": "xe533113f--767cd3--l",
};

module.exports = exports;
